import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=6bcdf92e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=6bcdf92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcdf92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bcdf92e')) {
      api.createRecord('6bcdf92e', component.options)
    } else {
      api.reload('6bcdf92e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=6bcdf92e&scoped=true&", function () {
      api.rerender('6bcdf92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8HyQL0UOwUS3s/JS/comp/DocBox.vue"
export default component.exports